import { useI18n } from "vue-i18n";
import { computed } from "vue";

export function useFieldOptions() {
    const { t } = useI18n();

    const headingTextSizeOptions = computed(() => [
        { value: "text-4xl sm:text-5xl", label: t("page.block.fieldOptions.textSize.default") },
        { value: "text-sm", label: t("page.block.fieldOptions.textSize.small") },
        { value: "text-base", label: t("page.block.fieldOptions.textSize.base") },
        { value: "text-lg", label: t("page.block.fieldOptions.textSize.large") },
        { value: "text-xl", label: t("page.block.fieldOptions.textSize.xl") },
        { value: "text-2xl", label: t("page.block.fieldOptions.textSize.2xl") },
        { value: "text-3xl", label: t("page.block.fieldOptions.textSize.3xl") },
        { value: "text-4xl", label: t("page.block.fieldOptions.textSize.4xl") },
        { value: "text-5xl", label: t("page.block.fieldOptions.textSize.5xl") },
        { value: "text-6xl", label: t("page.block.fieldOptions.textSize.6xl") },
    ]);

    const textAlignOptions = computed(() => [
        { value: "text-left", label: t("page.block.fieldOptions.textAlign.left") },
        { value: "text-center", label: t("page.block.fieldOptions.textAlign.center") },
    ]);

    const maxWidthOptions = computed(() => [
        { value: "max-w-2xl", label: t("page.block.fieldOptions.maxWidth.2xl") },
        { value: "max-w-3xl", label: t("page.block.fieldOptions.maxWidth.3xl") },
        { value: "max-w-4xl", label: t("page.block.fieldOptions.maxWidth.4xl") },
        { value: "max-w-5xl", label: t("page.block.fieldOptions.maxWidth.5xl") },
        { value: "max-w-6xl", label: t("page.block.fieldOptions.maxWidth.6xl") },
        { value: "max-w-7xl", label: t("page.block.fieldOptions.maxWidth.7xl") },
    ]);

    const elementAlignOptions = computed(() => [
        { value: "ml-0", label: t("page.block.fieldOptions.elementAlign.left") },
        { value: "mx-auto", label: t("page.block.fieldOptions.elementAlign.center") },
    ]);

    const paddingTopOptions = computed(() => [
        { value: "pt-0", label: t("page.block.fieldOptions.padding.none") },
        { value: "pt-4", label: t("page.block.fieldOptions.padding.small") },
        { value: "pt-8", label: t("page.block.fieldOptions.padding.medium") },
        { value: "pt-16", label: t("page.block.fieldOptions.padding.large") },
        { value: "pt-24 lg:pt-32", label: t("page.block.fieldOptions.padding.default") },
    ]);

    const paddingBottomOptions = computed(() => [
        { value: "pb-0", label: t("page.block.fieldOptions.padding.none") },
        { value: "pb-4", label: t("page.block.fieldOptions.padding.small") },
        { value: "pb-8", label: t("page.block.fieldOptions.padding.medium") },
        { value: "pb-16", label: t("page.block.fieldOptions.padding.large") },
        { value: "pb-24 lg:pb-32", label: t("page.block.fieldOptions.padding.default") },
    ]);

    const paragraphTextSizeOptions = computed(() => [
        { value: "text-sm", label: t("page.block.fieldOptions.textSize.small") },
        { value: "text-base", label: t("page.block.fieldOptions.textSize.base") },
        { value: "text-lg", label: t("page.block.fieldOptions.textSize.large") },
        { value: "text-xl", label: t("page.block.fieldOptions.textSize.xl") },
        { value: "text-2xl", label: t("page.block.fieldOptions.textSize.2xl") },
        { value: "text-3xl", label: t("page.block.fieldOptions.textSize.3xl") },
    ]);

    const flexJustifyOptions = computed(() => [
        { value: "justify-start", label: t("page.block.fieldOptions.flexJustify.left") },
        { value: "justify-center", label: t("page.block.fieldOptions.flexJustify.center") },
        { value: "justify-end", label: t("page.block.fieldOptions.flexJustify.right") },
    ]);

    return {
        headingTextSizeOptions,
        textAlignOptions,
        maxWidthOptions,
        elementAlignOptions,
        paddingTopOptions,
        paddingBottomOptions,
        paragraphTextSizeOptions,
        flexJustifyOptions,
    };
}
